import { render, staticRenderFns } from "./PNF.vue?vue&type=template&id=aeb21962&scoped=true&"
import script from "./PNF.vue?vue&type=script&lang=js&"
export * from "./PNF.vue?vue&type=script&lang=js&"
import style0 from "./PNF.vue?vue&type=style&index=0&id=aeb21962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb21962",
  null
  
)

export default component.exports